export default __webpack_public_path__ + "static/media/shannelSaskia.48457ebf.jpg";